<a *ngFor="let item of links" [href]="item.link" rel="noopener noreferrer" target="_blank">
	{{ item.name }}
</a>
